import React, { Component } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import Validator from 'validatorjs';

import Uuid from '../../../../support/Uuid';
import { FormControl } from '../../../../facturotopia';

class EmisorSeriesUpsertForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
      isValid: false,
      tipos: [
        {
          label: 'Seleccionar',
          value: '',
        },
        {
          label: 'Ingreso',
          value: 'ingreso',
        },
        {
          label: 'Egreso',
          value: 'egreso',
        },
        {
          label: 'Traslado',
          value: 'traslado',
        },
        {
          label: 'Nómina',
          value: 'nomina',
        },
        {
          label: 'Pago',
          value: 'pago',
        },
        {
          label: 'Retención',
          value: 'retencion',
        },
      ],
      data: {
        id: Uuid.v4(),
      },
    };
  }

  get rules() {
    return {
      tipo: ['required'],
      serie: ['required'],
      folio: ['required'],
    };
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  }

  handleOnChange = (value) => {
    const { step } = this.state;
    const data = {
      ...this.state.data,
      ...value,
    };

    this.validate(data);

    this.setState({
      data,
      step,
    });
  };

  handleOnAddSerie = () => {
    this.props.onAdd({
      ...this.state.data,
      action: 'add',
    });

    this.setState({
      data: {
        id: Uuid.v4(),
      },
    });

    this.validate({});
  };

  render() {
    const { data, tipos, validator, isValid } = this.state;

    return (
      <>
        <Form autoComplete="off">
          <Row>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={3}
            >
              <FormControl
                type="select"
                label="Tipo"
                name="tipo"
                placeholder=""
                help=""
                validator={validator}
                value={data.tipo}
                options={tipos}
                autoFocus={true}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              xs={12}
              sm={12}
              md={4}
              lg={2}
            >
              <FormControl
                type="text"
                label="Serie"
                name="serie"
                placeholder=""
                help=""
                validator={validator}
                value={data.serie}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              xs={12}
              sm={12}
              md={4}
              lg={2}
            >
              <FormControl
                type="text"
                label="Folio"
                name="folio"
                placeholder=""
                help=""
                validator={validator}
                value={data.folio}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              xs={12}
              sm={12}
              md={4}
              lg={3}
            >
              <div className="b-block color-white">
                <Form.Label>Agregar</Form.Label>
              </div>
              <Button
                type="button"
                variant="secondary"
                disabled={!isValid}
                onClick={this.handleOnAddSerie}
              >
                Agregar
              </Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  }
}

export default EmisorSeriesUpsertForm;
